import React from 'react';
import { SvgIcon } from 'material-ui';

const ChevronDownIcon = props => (
  <SvgIcon {...props} viewBox='0 0 15 8' style={props.style}>
    <g
      id='Page-1'
      stroke='none'
      strokeWidth='1'
      fill='none'
      fillRule='evenodd'
      opacity='0.411798007'
    >
      <g id='seat_passengers_3' transform='translate(-244.000000, -312.000000)' fill='#9BA1AC'>
        <path
          d='M250.349672,316.01311 L255.626768,321.290207 C256.023905,321.687344 256.023905,322.331231 255.626768,322.728368 C255.229631,323.125505 254.585745,323.125505 254.188607,322.728368 L248.297853,316.837613 C248.072434,316.612195 247.974965,316.307278 248.005446,316.01311 C247.974965,315.718943 248.072434,315.414026 248.297853,315.188607 L254.188607,309.297853 C254.585745,308.900716 255.229631,308.900716 255.626768,309.297853 C256.023905,309.69499 256.023905,310.338877 255.626768,310.736014 L250.349672,316.01311 Z'
          id='open'
          transform='translate(251.962311, 316.013110) scale(-1, -1) rotate(-270.000000) translate(-251.962311, -316.013110) '
        />
      </g>
    </g>
  </SvgIcon>
);

export default ChevronDownIcon;



// WEBPACK FOOTER //
// ./src/icons/ChevronDownIcon.js